import { useEffect, useState, useRef } from 'react'
// @ts-ignore
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useTransition, animated, config } from '@react-spring/web'
import styled from 'styled-components'
import { RxClipboardCopy } from 'react-icons/rx'
import { FiCheck } from 'react-icons/fi'
import { IoIosShareAlt } from 'react-icons/io'

const CopyUrl = ({
  title,
  text,
  url,
  locale,
  buttonColor,
  inverted,
}: {
  title: string
  text: string
  url: string
  locale: 'fr' | 'de'
  buttonColor: string
  inverted: boolean
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [copied, setCopied] = useState(false)
  const timeout = useRef<NodeJS.Timeout | null>(null)
  const transitions = useTransition(copied && isMobile, {
    from: { opacity: 0, translateY: -10 },
    enter: { opacity: 1, translateY: 0 },
    leave: { opacity: 0, translateY: -10 },
    delay: 200,
    config: config.molasses,
  })

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffect(() => {
    if (copied) {
      timeout.current = setTimeout(() => {
        setCopied(false)
      }, 3000)

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'copyurl',
        event_label: `url:${url}`,
      })
    }
  }, [copied])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)

      if (timeout.current) {
        clearTimeout(timeout.current)
      }
    }
  }, [])

  return (
    <Container>
      <HeaderContent>
        {title} <IoIosShareAlt />
      </HeaderContent>
      <div>
        <InputContainer>
          {transitions(
            (transitionStyles, item) =>
              item && (
                <LabelContainer style={transitionStyles}>
                  <div
                    className={`ui pointing below ${
                      inverted ? 'white' : 'black'
                    } label`}
                  >
                    Copié!
                  </div>
                </LabelContainer>
              )
          )}
          <Input type='text' value={url} />
          <CopyToClipboard
            text={url}
            onCopy={() => {
              setCopied(true)
            }}
          >
            <Button>
              {copied ? <FiCheck /> : <RxClipboardCopy />}
              {!isMobile && (
                <div style={{ marginLeft: '.5em' }}>
                  {copied ? `Copié!` : 'Copier'}
                </div>
              )}
            </Button>
          </CopyToClipboard>
        </InputContainer>
      </div>
      <Text>{text}</Text>
    </Container>
  )
}

CopyUrl.defaultProps = {
  locale: 'de',
  url: window.location.href,
  inverted: false,
}

const Container = styled.div`
  font-family: var(--font-sans-serif);
  position: relative;
`
const InputContainer = styled.div`
  width: 100%;
  margin: 0.35rem 0;
  display: flex;
  align-items: stretch;
  font-size: 1em;
`
const Text = styled.div`
  opacity: 0.45;
  font-size: 0.65em;
  line-height: 1.2em;
  color: #ffffff;
`
const HeaderContent = styled.div``
const LabelContainer = styled(animated.div)`
  z-index: 2;
  position: absolute;
  top: -32px;
  right: -10px;
  display: none;
`
const Input = styled.input`
  font-family: var(--font-sans-serif);
  padding: 1rem 1rem;
  border: none;
  outline: none;
  width: 100%;
  font-size: 1em;
`
const Button = styled.button`
  font-family: var(--font-sans-serif);
  display: inline-flex;
  align-items: center;
  background-color: #6f7187;
  color: white;
  border: none;
  outline: none;
  font-size: 1em;
  padding: 0.5rem 1rem;
  cursor: pointer;
`

export default CopyUrl
